/* eslint-disable camelcase */

import ReduxService from 'src/redux/redux.service';
import { TrendsData } from './results.type';
import { RootState } from 'src/redux/redux-store';
import { invisiblyApi } from 'src/redux/api/invisibly-api';
import { createShare } from 'src/services/surveys/surveys.helpers';

const getUrl = (url: string) => {
  const state = ReduxService.Store.getState() as RootState;
  const isClientActive = state.userState.activeClient;
  return isClientActive ? url.replace('b2b', 'client') : url;
};

const getClientId = () => {
  const state = ReduxService.Store.getState() as RootState;
  const isClientActive = state.userState.activeClient;
  return isClientActive ? state.userState.activeClient?.ext_client_id ?? null : null;
};


interface GetTrendsDataParams {
  ext_survey_id: string;
  share?: boolean;
  interval?: number;
  start_date?: string;
  end_date?: string;
  selected_survey_answers?: string[];
}

interface SerializeQueryArgsParams {
  queryArgs: GetTrendsDataParams;
}

const trendsEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    getTrendsData: builder.query<TrendsData, GetTrendsDataParams>({
      query: ({ ext_survey_id, share, interval, start_date, end_date, selected_survey_answers }: GetTrendsDataParams) => ({
        method: 'get',
        params: {
          interval,
          start_date,
          end_date,
          selected_survey_answers: selected_survey_answers?.join(','),
          client_id: getClientId(),
        },
        url: createShare(getUrl(`b2b/survey/${ext_survey_id}/trends`), share ?? false, 'b2b'),
      }),
      serializeQueryArgs: ({ queryArgs: { ext_survey_id, interval, start_date, end_date, selected_survey_answers } }: SerializeQueryArgsParams) => ({
        ext_survey_id,
        interval,
        start_date,
        end_date,
        selected_survey_answers: selected_survey_answers && selected_survey_answers.length > 0
          ? [...selected_survey_answers].sort().join(',')
          : '',
      }),
      transformResponse(response: { item: TrendsData }): TrendsData {
        return response.item;
      },
    }),
  }),
});

export const {
  useGetTrendsDataQuery,
} = trendsEndpoints;

export { trendsEndpoints };
